// ============================================================
// useSchool Hook
// ============================================================

import { useContext } from 'react';
import { SchoolContext } from '@/auth/SchoolContext';

export function useSchool() {
  const context = useContext(SchoolContext);
  if (!context) {
    throw new Error('useSchool must be used within a SchoolProvider');
  }
  return context;
}
